import { useState } from 'react';
import auth from '../components/common/Auth';

// const userLoggedToken = auth.getAccessToken();

const getHeader = (newToken) => {

    const token = null;//(newToken)?newToken:userLoggedToken

    return {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Authorization" : "Bearer " + token
        }
    }
}

// Hook to get HTTP header.
// If token parameter is null, then takes token from user storage token.
export const useHeaderHTTP = (token) => {

    const headerHTTP = getHeader(token);
    
    const [ header, setHeader ] = useState(headerHTTP); 

    const setNewToken = (newToken) => {
        // TODO: TO CKECK
        setHeader(getHeader(newToken));
    }

    // const getNewToken = () => {
    //     TODO: Create new token 
    // }

    return {
        header,
        setHeader,
        setNewToken,
        // getNewToken,
    };

}



// import { useState } from 'react';

// export const useisLoading = (initialState = false) => {
    
//     // Variable to show/hide "spinner" while loading page.
//     const [ isLoading, setisLoading ] = useState(initialState); // false

//     const reset = () => {
//         setisLoading( initialState );
//     }

//     const showSpinner = () => {
//         setisLoading( true );
//     }

//     const hideSpinner = () => {
//         setisLoading( false );
//     }

//     return {
//         isLoading,
//         showSpinner,
//         hideSpinner,
//         reset
//     };

// }